export { subscribe, createSourceEventStream } from "./subscribe.mjs";



//////////////////
// WEBPACK FOOTER
// ./~/graphql/subscription/index.mjs
// module id = stiv
// module chunks = 9